import { ReactNode, useRef } from 'react';

/**
 * Keeps the children the dialog had while open, so they can animate out.
 */
export const useLastOpenChildren = (
  isOpen: boolean,
  children: ReactNode,
  hasExited: boolean
): ReactNode => {
  const lastOpenChildren = useRef<ReactNode>(null);

  if (isOpen) {
    lastOpenChildren.current = children;
  } else if (hasExited) {
    lastOpenChildren.current = null;
  }

  return isOpen ? children : lastOpenChildren.current;
};
